import React, { useMemo, useState } from 'react';
import { useDebounce } from '@uidotdev/usehooks';
import { ShortCategoryListItemViewModel } from '@/types/cml-api';
import { TextField } from '@/features/form';
import { IconSearchNormal } from '@/features/icons';
import { cn } from '@/utils/cn';
import { useVideosFilterContext } from '../../context';
interface Props {
  activeFilters: ShortCategoryListItemViewModel[];
  changeHandler: (value: number) => void;
  mode: 'mobile' | 'desktop';
}
const CategoriesContent = ({
  activeFilters,
  changeHandler,
  mode
}: Props) => {
  const {
    categories
  } = useVideosFilterContext();
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedTerm = useDebounce(searchTerm, 300);
  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };
  const handleChange = (value: number) => {
    changeHandler(value);
  };
  const sortedItems = useMemo(() => {
    return mode === 'desktop' ? categories : categories?.sort((a, b) => {
      const aIsActive = activeFilters.some(filter => filter.id?.value === a.id?.value);
      const bIsActive = activeFilters.some(filter => filter.id?.value === b.id?.value);
      if (aIsActive && !bIsActive) return -1;
      if (!aIsActive && bIsActive) return 1;
      return (a.title || '').localeCompare(b.title || '');
    });
  }, [activeFilters, categories, mode]);
  const filteredItems = sortedItems?.filter(item => item?.title?.toLowerCase().includes(debouncedTerm.toLowerCase()));
  return <div className='flex flex-col' data-sentry-component="CategoriesContent" data-sentry-source-file="categories-content.tsx">
            <form toolname='category-search' tooldescription='search in categories' className='w-full'>
                <TextField name='category-search' id='category-search' rightIcon={<IconSearchNormal className='h-6 w-6 text-text-mediumGray' />} inputSize='medium' placeholder='جست‌وجوی دسته‌بندی' className='mx-2 my-1' onChange={e => handleSearchChange(e.target.value.trimStart())} value={searchTerm} fillInlineMessageSpace toolparamdescription='search in categories query' data-sentry-element="TextField" data-sentry-source-file="categories-content.tsx" />
            </form>
            {filteredItems?.map(({
      id,
      title
    }) => {
      const value = id?.value;
      const isActive = activeFilters.some(filter => filter.id?.value === value);
      if (!value) return null;
      return <button key={value} onClick={() => handleChange(value)} className={cn('border-b border-border-gray-light px-2 py-3 text-right lg:border-b-0 lg:px-2 lg:py-2 lg:text-body-14', {
        'bg-surface-solid-50 font-medium text-primary-main': isActive
      })}>
                        {title}
                    </button>;
    })}
        </div>;
};
export default CategoriesContent;